import { render, staticRenderFns } from "./GroupDeviceItem.vue?vue&type=template&id=542b6bc5&scoped=true"
import script from "./GroupDeviceItem.vue?vue&type=script&lang=ts"
export * from "./GroupDeviceItem.vue?vue&type=script&lang=ts"
import style0 from "./GroupDeviceItem.vue?vue&type=style&index=0&id=542b6bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b6bc5",
  null
  
)

export default component.exports